<template>
	<div>
		<div class="page-notfound-main-container">
			<div class="page-notfound-white-contaniner">
				<div class="page-notfound-background-image-pos">
					<img
						width="100%"
						src="../../assets/icons/error/bottomimg.svg"
						alt=""
					/>
				</div>
				<div class="page-notfound-first-div">
					<div class="page-notfound-blue-txt">404 Error:Page Not Found</div>
					<div class="page-notfound-black-txt">
						It seems like the page you're looking for doesn't exist.
					</div>
					<div class="page-notfound-black-small-txt mt-5">
						Here are a few things you can try:
					</div>
					<div class="page-notfound-grey-txt mt-3">Check the URL:</div>
					<div class="page-notfound-grey-txt-2">
						Make sure you've entered the correct URL.
					</div>
					<div class="page-notfound-grey-txt mt-3">Go back:</div>
					<div class="page-notfound-grey-txt-2">
						Use your browser's back button to return to the previous page.
					</div>
					<div class="grey-txt mt-3">Contact Us:</div>
					<div class="page-notfound-grey-txt-2">
						If you believe there's an issue, feel free to
						<a
							href="https://www.hire3x.com/contactus"
							class="blue-underline"
							target="_blank"
							>Contact Us</a
						>
						for assistance.
					</div>
				</div>
				<div class="page-notfound-second-div">
					<img width="100%" src="../../assets/icons/error/404.svg" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Job Not Found",
	data() {
		return {};
	},
};
</script>
<style>
body {
	margin: 0;
}

.page-notfound-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 60px;
}

.page-notfound-white-contaniner {
	background-color: #ffffff;
	height: 90%;
	width: 90%;
	border: Mixed solid #8c8c8c54;
	border-radius: 8px;
	box-shadow: 0px 4px 8px 0px #0000002b;
	display: flex;
	align-items: center;
	justify-content: space-around;
	position: relative;
	padding: 2.5rem;
	overflow-y: auto;
}

.page-notfound-background-image-pos {
	position: absolute;
	bottom: 0px;
	left: 0px;
	z-index: 1;
}

.page-notfound-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 40px;
	font-weight: 600;
	color: #20639b;
}

.page-notfound-black-txt {
	font-family: "Lato", sans-serif;
	font-size: 22px;
	font-weight: 400;
	color: #000000;
}

.page-notfound-black-small-txt {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #000000;
}

.page-notfound-grey-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 15px;
	font-weight: 600;
	color: #3a3c40;
}

.page-notfound-grey-txt-2 {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 400;
	color: #3a3c40;
}

.page-notfound-blue-underline {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #20639b;
	text-decoration: underline;
}
.page-notfound-first-div,
.page-notfound-second-div {
	z-index: 2;
}
@media only screen and (max-width: 600px) {
	.page-notfound-first-div {
		order: 1;
	}
	.page-notfound-second-div {
		order: 0;
	}
	.page-notfound-white-contaniner {
		flex-direction: column;
		padding: 1rem;
		height: 95%;
	}
}
</style>
